import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { BehaviorSubject, Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { UtilityService } from "../Utils/utility.service";

const AUTH_API = environment.serverURL;
@Injectable({
  providedIn: "root",
})
export class ServiceProviderService {
  private editServiceProviderSub = new BehaviorSubject<any>(null);
  _editServiceProviderObservable = this.editServiceProviderSub.asObservable();
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private _utilityService: UtilityService,
    private spinner: NgxSpinnerService
  ) {}
  setEditServiceProvider(data) {
    this.editServiceProviderSub.next(data);
  }
  addServiceProvider(data): Observable<any> {
    // console.log('data before calling service', data)

    return this.http.post<any>(AUTH_API + "/admin/addServiceProvider", data);
    // return this.http.post<any>(this.api + '/admin/addServiceProvider', data)
  }
  listServiceProvider(payload): Observable<any> {
    this.spinner.show();
    return this.http
      .post<any>(AUTH_API + "/admin/get/serviceproviders", payload)
      .pipe(
        map((result: any) => {
          // console.log('result', result);
          var data = [];
          if (result.success == true) {
            result.data.forEach((element, index) => {
              data.push({
                _id: element?._id,
                companyName: element?.companyName || element?.ownerName,
                totalOngoing: element?.totalOngoing,
                avgRating: element?.avgRating
                  ? Number(element?.avgRating).toFixed(2)
                  : 0,
                categorieName: this.checkIsArrayOrObject(element?.catagories), //element?.catagories.map((e) => { return e.catagorieName }),
                // createdAt_Local: moment(element.createdAt_Local).format('DD/MM/YYYY hh:mm a'),
                // categorieName: element?.catagories.map((e) => { return e.catagorieName }),
                // createdAt_Local:  moment(element.createdAt_Local).format('DD/MM/YYYY hh:mm a') ,
                createdAt_Local: this._utilityService.formatDate(
                  element.createdAt_Local
                ),
                numberWithCode: element?.numberWithCode,
                ownerName: element?.ownerName,
                isActive: element?.isActive,
              });
            });
            this.spinner.hide();
          } else {
            this.spinner.hide();

            data = [];
          }
          this.spinner.hide();

          // console.log(data);
          return { data: data, totalCount: result.totalCount };
        }),
        catchError((err: any) => {
          this.spinner.hide();
          return throwError(err);
        })
      );
  }
  // return this.http.get<any>(this.api + '/admin/get/serviceproviders');

  checkIsArrayOrObject(obj: any) {
    // // console.log("\n isArray == ",Array.isArray(obj),obj);

    if (Array.isArray(obj)) {
      return obj.map((e) => {
        return e.catagorieName;
      });
    } else {
      return obj["catagorieName"];
    }
  }

  getMainCategories() {
    // let header = new HttpHeaders().set(
    //     "Authorization",
    //     // localStorage.getItem("token")
    //     "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJPbmxpbmUgSldUIEJ1aWxkZXIiLCJpYXQiOjE2MjQ5NjAwMzAsImV4cCI6MTY1NjQ5NjAzMCwiYXVkIjoid3d3LmV4YW1wbGUuY29tIiwic3ViIjoianJvY2tldEBleGFtcGxlLmNvbSIsInJvbGUiOiJVc2VyIiwidXNlcklkIjoiNjA1OWQ4Mjc2NWUzYTIzNTI4ZDU1ZDc3In0.x4j3_jPd0tkkVOy-Pg1MV_0UkbeYVkk-5ycBxWLeU3w"
    // );

    return this.http.post<any>(AUTH_API + "/user/getMainCatagories", {}).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error) => {
        // console.log('inside catch error')
        return throwError("Something went wrong!");
      })
    );
  }

  viewServiceProvider(payload): Observable<any> {
    this.spinner.show();

    return this.http
      .post<any>(AUTH_API + "/admin/view-serviceProvider", payload)
      .pipe(
        map((result: any) => {
          this.spinner.hide();
          return result;
        }),
        catchError((err: any) => {
          this.spinner.hide();
          return throwError(err);
        })
      );
    // return this.http.post<any>(this.api + '/admin/view-serviceProvider', payload)
  }
  editServiceProvider(payload): Observable<any> {
    return this.http.post<any>(
      AUTH_API + "/admin/updateServiceProvider",
      payload
    );
    // return this.http.post<any>(this.api + '/admin/updateServiceProvider', payload)
  }
  checkBranchAssignedToStaff(payload): Observable<any> {
    return this.http.post<any>(
      AUTH_API + "/admin/check-staff-branches",
      payload
    );
    // return this.http.post<any>(this.api + '/admin/updateServiceProvider', payload)
  }

  statusToggle(data) {
    return this.http.post(`${AUTH_API}/admin/status-toggle`, data).pipe(
      map((result: any) => {
        return result;
      }),
      catchError((err: any) => {
        this.spinner.hide();
        return throwError(err);
      })
    );
  }
  addServicesOnBehalfOfSPA(payload): Observable<any> {
    return this.http.post<any>(
      AUTH_API + "/admin/on-behalf-of-spa-add-category",
      payload
    );
  }

  viewCategory(data): Observable<any> {
    return this.http.post(AUTH_API + "/admin/view-category", data);
  }

  viewUpdatedCategory(data): Observable<any> {
    return this.http.post(AUTH_API + "/admin/view-updated-category", data);
  }

  addCategorySPA(payload): Observable<any> {
    return this.http.post<any>(
      AUTH_API + "/serviceProviderAdmin/add/Services",
      payload
    );
  }

  viewCategorySPA(data): Observable<any> {
    return this.http.post(
      AUTH_API + "/serviceProviderAdmin/view-category",
      data
    );
  }

  editCategorySPA(payload): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return this.http.post<any>(
      AUTH_API + "/serviceProviderAdmin/edit-category",
      payload
      // { headers }
    );
  }

  viewSpaCategory(payload): Observable<any> {
    return this.http.post<any>(AUTH_API + "/admin/view-spa-category", payload);
  }

  getOtherServices(payload): Observable<any> {
    return this.http.post<any>(
      AUTH_API + "/serviceProviderAdmin/get-other-services",
      payload
    );
  }
  approveDeclineRequest(payload): Observable<any> {
    return this.http.post<any>(
      AUTH_API + "/admin/approve-decline-service-provider",
      payload
    );
  }

  listServiceProviderFilter(payload): Observable<any> {
    return this.http
      .post<any>(AUTH_API + "/admin/get/serviceproviders-filter", payload)
      .pipe(
        map((result: any) => {
          // console.log('result', result);
          var data = [];
          if (result.success == true) {
            result.data.forEach((element, index) => {
              data.push({
                _id: element?._id,
                companyName: element?.companyName || element?.ownerName,
                totalOngoing: element?.totalOngoing,
                avgRating: element?.avgRating
                  ? Number(element?.avgRating).toFixed(2)
                  : 0,
                categorieName: this.checkIsArrayOrObject(element?.catagories), //element?.catagories.map((e) => { return e.catagorieName }),
                // createdAt_Local: moment(element.createdAt_Local).format('DD/MM/YYYY hh:mm a'),
                // categorieName: element?.catagories.map((e) => { return e.catagorieName }),
                // createdAt_Local:  moment(element.createdAt_Local).format('DD/MM/YYYY hh:mm a') ,
                createdAt_Local: this._utilityService.formatDate(
                  element.createdAt_Local
                ),
                numberWithCode: element?.numberWithCode,
                ownerName: element?.ownerName,
                isActive: element?.isActive,
              });
            });
          } else {
            data = [];
          }
          // console.log(data);
          return { data: data, totalCount: result.totalCount };
        })
      );
  }

  // *******To check child category already exists or not ******
  checkChildCategoryExistValidatorSPA(payload): Observable<any> {
    return this.http.post<any>(
      AUTH_API + "/serviceProviderAdmin/category-validator",
      payload
    );
  }

  categoryListing(payload?) {
    return this.http
      .post<any>(AUTH_API + "/admin/get-all-category-list", payload)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          // console.log('inside catch error')
          return throwError("Something went wrong!");
        })
      );
    // return this.http.post(AUTH_API + '/admin/get-all-category-list', payload);
  }

  // ******SPA sign up ******
  addServicesSPASignUp(payload): Observable<any> {
    return this.http.post<any>(AUTH_API + "/auth/spa-add-category", payload);
  }

  spaSignUp(data): Observable<any> {
    return this.http.post<any>(AUTH_API + "/auth/spa-sign-up", data);
  }
}
